export const notificationActionTypes={
    GET_ALL_NOTIFICATIONS_START: 'GET_ALL_NOTIFICATIONS',
    GET_ALL_NOTIFICATIONS_SUCCESS: 'GET_ALL_NOTIFICATIONS_SUCCESS',
    GET_ALL_NOTIFICATIONS_FAILURE: 'GET_ALL_NOTIFICATIONS_FAILURE',
    DELETE_NOTIFICATION_START: 'DELETE_NOTIFICATION',
    DELETE_NOTIFICATION_SUCCESS: 'DELETE_NOTIFICATION_SUCCESS',
    DELETE_NOTIFICATION_FAILURE: 'DELETE_NOTIFICATION_FAILURE',
    DELETE_ALL_NOTIFICATIONS_START: 'DELETE_ALL_NOTIFICATIONS',
    DELETE_ALL_NOTIFICATIONS_SUCCESS: 'DELETE_ALL_NOTIFICATIONS_SUCCESS',
    DELETE_ALL_NOTIFICATIONS_FAILURE: 'DELETE_ALL_NOTIFICATIONS_FAILURE',
    ADD_NOTIFICATION:'ADD_NOTIFICATION',
    TOGGLE_NOTIFICATION_BAR:'TOGGLE_NOTIFICATION_BAR'
}